export const closingStation = `
id
station {
    id
}
location {
    id
}
minimumBookingWindow
startTime
endTime
`;
